import React, { useState, useEffect } from "react";
import { Link, NavLink } from "react-router-dom";
import Logo from '../../Assets/images/q-nexus.png';
import { Button } from "reactstrap";
import { useAuth } from "../../Context/AuthenticateProvider";

const AdminHeader = () => {
    const { logOut } = useAuth();
    const [communityOpen, setCommunityOpen] = useState(false);
    const [mobileOpen, setMobileOpen] = useState(false);

    // Close mobile menu automatically when screen resizes to desktop
    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth >= 992) setMobileOpen(false);
        };
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    // Prevent background scrolling when mobile menu is open
    useEffect(() => {
        document.body.style.overflow = mobileOpen ? "hidden" : "";
        return () => { document.body.style.overflow = ""; };
    }, [mobileOpen]);

    const handleMobileLinkClick = () => {
        setMobileOpen(false);
        setCommunityOpen(false);
    };

    return (
        <>
            <nav className="navbar navbar-expand-lg admin-header sticky-top shadow-sm">
                <div className="container-fluid px-3 px-lg-4">

                    {/* Brand - UNTOUCHED */}
                    <Link className="navbar-brand fw-semibold d-flex align-items-center" to="/admin/dashboard">
                        <img className="logo" src={Logo} alt="Logo" />
                    </Link>

                    {/* Custom Mobile Toggle (Hides default Bootstrap toggler on mobile) */}
                    <button
                        className="navbar-toggler d-lg-none border-0 shadow-none p-2"
                        type="button"
                        onClick={() => setMobileOpen(!mobileOpen)}
                        aria-label="Toggle navigation"
                    >
                        <i className={`bx ${mobileOpen ? 'bx-x' : 'bx-menu'} fs-4`} style={{ color: '#1e3a8a' }}></i>
                    </button>

                    {/* Desktop Nav - UNTOUCHED */}
                    <div className="collapse navbar-collapse mt-3 mt-lg-0 d-none d-lg-block" id="adminNavbar">
                        <ul className="navbar-nav ms-auto align-items-lg-center gap-lg-2">
                            <li className="nav-item">
                                <NavLink to="/admin/dashboard" className="nav-link"><i className="bx bx-home-alt me-1" />Dashboard</NavLink>
                            </li>
                            <li className="nav-item">
                                <NavLink to="/admin/logs" className="nav-link"><i className="bx bx-list-check me-1" />Activity Log</NavLink>
                            </li>
                            <li className="nav-item">
                                <NavLink to="/admin/list" className="nav-link"><i className="bx bx-buildings me-1" />Users</NavLink>
                            </li>
                            <li className="nav-item">
                                <NavLink to="/admin/chat-list" className="nav-link"><i className="bx bx-message-square-dots me-1" />Chats</NavLink>
                            </li>
                            <li className="nav-item">
                                <NavLink to="/admin/announcement" className="nav-link"><i className="bx bx-bell me-1" />Announcement</NavLink>
                            </li>

                            {/* Community dropdown */}
                            <li className="nav-item">
                                <NavLink to="/admin/communities" className="nav-link">
                                    <i className="bx bx-group me-1" />
                                    All Communities
                                </NavLink>
                            </li>

                            <li className="nav-item">
                                <NavLink to="/admin/deals" className="nav-link"><i className="bx bx-briefcase-alt-2 me-1" />Deals</NavLink>
                            </li>
                            <li className="nav-item">
                                <NavLink to="/admin/top-vendors" className="nav-link"><i className="bx bxs-trophy me-1" />Top Vendors</NavLink>
                            </li>
                            <li className="nav-item">
                                <NavLink to="/admin/verification" className="nav-link"><i className="bx bx-shield-quarter me-1" />Verification</NavLink>
                            </li>


                            {/* Logout */}
                            <li className="nav-item mt-2 mt-lg-0 ms-lg-2">
                                <Button color="danger" size="sm" onClick={logOut}><i className="bx bx-log-out me-1" />Logout</Button>
                            </li>
                        </ul>
                    </div>
                </div>
            </nav>

            {/* ── PREMIUM MOBILE MENU ── */}
            <div
                className={`admin-mobile-overlay ${mobileOpen ? "active" : ""}`}
                onClick={() => setMobileOpen(false)}
            />
            <div className={`admin-mobile-menu d-lg-none ${mobileOpen ? "open" : ""}`}>
                <div className="mobile-menu-header d-flex justify-content-between align-items-center mb-4 pb-3 border-bottom">
                    <span className="fw-bold text-dark fs-5">Menu</span>
                    <button className="btn btn-sm btn-light rounded-circle shadow-sm" onClick={() => setMobileOpen(false)}>
                        <i className="bx bx-x fs-5 text-danger"></i>
                    </button>
                </div>

                <ul className="list-unstyled mb-0 d-flex flex-column gap-1">
                    <li><NavLink to="/admin/dashboard" className="mobile-nav-link" onClick={handleMobileLinkClick}><i className="bx bx-home-alt me-2" />Dashboard</NavLink></li>
                    <li><NavLink to="/admin/logs" className="mobile-nav-link" onClick={handleMobileLinkClick}><i className="bx bx-list-check me-2" />Activity Log</NavLink></li>
                    <li><NavLink to="/admin/list" className="mobile-nav-link" onClick={handleMobileLinkClick}><i className="bx bx-buildings me-2" />Users</NavLink></li>
                    <li><NavLink to="/admin/chat-list" className="mobile-nav-link" onClick={handleMobileLinkClick}><i className="bx bx-message-square-dots me-2" />Chats</NavLink></li>
                    <li><NavLink to="/admin/announcement" className="mobile-nav-link" onClick={handleMobileLinkClick}><i className="bx bx-bell me-2" />Announcement</NavLink></li>

                    {/* Mobile Community Accordion */}
                    <li>
                        <button
                            className="mobile-nav-link w-100 d-flex justify-content-between align-items-center"
                            onClick={() => setCommunityOpen(!communityOpen)}
                            style={{ background: 'none', border: 'none' }}
                        >
                            <span><i className="bx bx-group me-2" />Community</span>
                            <i className={`bx bx-chevron-down transition-transform ${communityOpen ? "rotate-180" : ""}`} style={{ transition: '0.2s', transform: communityOpen ? 'rotate(180deg)' : 'rotate(0)' }}></i>
                        </button>
                        {communityOpen && (
                            <ul className="list-unstyled ms-4 mt-1 mb-2 d-flex flex-column gap-1 border-start ps-3">
                                <li><NavLink to="/admin/communities" className="mobile-sub-link" onClick={handleMobileLinkClick}><i className="bx bx-group me-2" />All Communities</NavLink></li>
                                <li><NavLink to="/admin/community-members" className="mobile-sub-link" onClick={handleMobileLinkClick}><i className="bx bx-user-check me-2" />Members</NavLink></li>
                            </ul>
                        )}
                    </li>

                    <li><NavLink to="/admin/deals" className="mobile-nav-link" onClick={handleMobileLinkClick}><i className="bx bx-briefcase-alt-2 me-2" />Deals</NavLink></li>
                    <li><NavLink to="/admin/top-vendors" className="mobile-nav-link" onClick={handleMobileLinkClick}><i className="bx bxs-trophy me-2" />Top Vendors</NavLink></li>
                    <li><NavLink to="/admin/verification" className="mobile-nav-link" onClick={handleMobileLinkClick}><i className="bx bx-shield-quarter me-2" />Verification</NavLink></li>
                </ul>

                <div className="mt-4 pt-3 border-top">
                    <Button color="danger" className="w-100 rounded-pill" onClick={logOut}>
                        <i className="bx bx-log-out me-2" />Logout
                    </Button>
                </div>
            </div>

            {/* Scoped Mobile Styles */}
            <style>{`
                /* Backdrop overlay */
                .admin-mobile-overlay {
                    position: fixed;
                    inset: 0;
                    background: rgba(15, 23, 42, 0.5);
                    backdrop-filter: blur(4px);
                    z-index: 1040;
                    opacity: 0;
                    visibility: hidden;
                    transition: all 0.3s ease;
                }
                .admin-mobile-overlay.active {
                    opacity: 1;
                    visibility: visible;
                }

                /* Slide-down menu container */
                .admin-mobile-menu {
                    position: fixed;
                    top: 0;
                    left: 0;
                    width: 100%;
                    height: 100vh;
                    background: #ffffff;
                    z-index: 1050;
                    transform: translateY(-100%);
                    transition: transform 0.35s cubic-bezier(0.4, 0, 0.2, 1);
                    overflow-y: auto;
                    padding: 24px;
                    box-shadow: 0 10px 25px rgba(0,0,0,0.1);
                }
                .admin-mobile-menu.open {
                    transform: translateY(0);
                }

                /* Menu Links */
                .mobile-nav-link {
                    display: flex;
                    align-items: center;
                    padding: 12px 16px;
                    font-size: 1rem;
                    font-weight: 500;
                    color: #334155;
                    text-decoration: none;
                    border-radius: 10px;
                    transition: all 0.2s ease;
                }
                .mobile-nav-link:hover, .mobile-nav-link.active {
                    background: #f0f4f8;
                    color: #1e3a8a;
                }
                .mobile-nav-link i {
                    font-size: 1.2rem;
                    color: #64748b;
                    transition: color 0.2s;
                }
                .mobile-nav-link:hover i, .mobile-nav-link.active i {
                    color: #1e3a8a;
                }

                /* Submenu links */
                .mobile-sub-link {
                    display: flex;
                    align-items: center;
                    padding: 10px 16px;
                    font-size: 0.9rem;
                    font-weight: 400;
                    color: #64748b;
                    text-decoration: none;
                    border-radius: 8px;
                    transition: all 0.2s;
                }
                .mobile-sub-link:hover, .mobile-sub-link.active {
                    background: #fff;
                    color: #1e3a8a;
                }
            `}</style>
        </>
    );
};

export default AdminHeader;